<div class="park-turbines-container border rounded">
  <div>
    @if (aggregationMethod !== 'park') {
      <button class="btn btn-default p-0" (click)="removeList()" [disabled]="disabled">
        <i class="far fa-times"></i>
      </button>
    }
    <span class="font-weight-bold">{{ park.name | titlecase }}</span>
    <button class="btn btn-default float-right" (click)="toggleList()">
      @if (closedList) {
        <i class="far fa-chevron-down"></i>
      }
      @if (!closedList) {
        <i class="far fa-chevron-up"></i>
      }
    </button>
  </div>
  <div class="row selected-list d-inline-block text-truncate">
    {{ selectedList |uppercase }}
  </div>
  @if (!closedList) {
    <div class="turbines-list border rounded p-2">
      <div class="row all-turbines-selection">
        <div class="col-6">
          <mat-checkbox [checked]="allSelected" [color]="'primary'" [disabled]="disabled" (change)="selectAllTurbines()">
            {{'PLANNING.MODALS.ALL_TURBINES' |translate}}
          </mat-checkbox>
        </div>
        <div class="col-5">
          <span class="pt-1 font-weight-bold float-right">{{ getSelected }} {{'COMMON.OF' |translate}} {{ park.turbines?.length }}</span>
        </div>
      </div>
      <div class="row turbines-selections-container">
        @for (turbine of park.turbines; track $index) {
          <div class="col-4 turbines-selections">
            <mat-checkbox [checked]="turbine.selected" [color]="'primary'" [disabled]="disabled"
              (change)="selectTurbine($event, turbine)">
              {{ turbine.code.replace('_', ' ').replace('_', ' ') | uppercase}}
            </mat-checkbox>
          </div>
        }
      </div>
    </div>
  }
</div>